import AaveIcon from './variants/aave.js';
import ArbitrumIcon from './variants/arbitrum.js';
import AstarIcon from './variants/astar.js';
import AudiusIcon from './variants/audius.js';
import AvalancheIcon from './variants/avalanche.js';
import BaseIcon from './variants/base.js';
import BbsolIcon from './variants/bbsol.js';
import BenqiIcon from './variants/benqi.js';
import BinanceCoinIcon from './variants/binance-coin.js';
import BitcoinIcon from './variants/bitcoin.js';
import BonkIcon from './variants/bonk.js';
import CeloIcon from './variants/celo.js';
import CloudIcon from './variants/cloud.js';
import DegenIcon from './variants/degen.js';
import DriftIcon from './variants/drift.js';
import EtherIcon from './variants/ether.js';
import EURCIcon from './variants/eurc.js';
import HelioIcon from './variants/helio.js';
import ImmutableIcon from './variants/immutable.js';
import IndexCoopIcon from './variants/index-coop.js';
import InfinityIcon from './variants/infinity.js';
import JupiterIcon from './variants/jupiter.js';
import KaminoIcon from './variants/kamino.js';
import KromaIcon from './variants/kroma.js';
import MagicEdenIcon from './variants/magic-eden.js';
import MagicSquareIcon from './variants/magic-square.js';
import MantleIcon from './variants/mantle.js';
import MoonbeamIcon from './variants/moonbeam.js';
import MotherIcon from './variants/mother.js';
import OptimismIcon from './variants/optimism.js';
import PolygonIcon from './variants/polygon.js';
import QuickSwapIcon from './variants/quickswap.js';
import RariIcon from './variants/rari.js';
import RaribleIcon from './variants/rarible.js';
import RaydiumIcon from './variants/raydium.js';
import ShapeShiftIcon from './variants/shapeshift.js';
import SolanaIcon from './variants/solana.js';
import StakedAvaxIcon from './variants/staked-avax.js';
import TensorIcon from './variants/tensor.js';
import TetherIcon from './variants/tether.js';
import ThorchainIcon from './variants/thorchain.js';
import ThorswapIcon from './variants/thorswap.js';
import UniswapIcon from './variants/uniswap.js';
import USDCIcon from './variants/usdc.js';
import VaultCraftIcon from './variants/vaultcraft.js';
import VertexIcon from './variants/vertex.js';
import YeetIcon from './variants/yeet.js';
import ZkSyncIcon from './variants/zksync.js';
import { tw } from '../../utils/classnames.js';
export const ASSET_ICON_CONFIGS = {
    aave: {
        Logo: AaveIcon,
        bgColor: '#dc7aff',
        bgClassName: tw `ui-bg-[#dc7aff] after:ui-bg-[#dc7aff]`,
        fgColor: '#dc7aff',
        fgClassName: tw `ui-text-[#dc7aff]`,
    },
    arbitrum: {
        Logo: ArbitrumIcon,
        bgColor: '#7b8aff',
        bgClassName: tw `ui-bg-[#7b8aff] after:ui-bg-[#7b8aff]`,
        fgColor: '#7b8aff',
        fgClassName: tw `ui-text-[#7b8aff]`,
        logoSizeClassName: tw `ui-size-[50%]`,
    },
    astar: {
        Logo: AstarIcon,
        bgColor: '#509ffd',
        bgClassName: tw `ui-bg-[#509ffd] after:ui-bg-[#509ffd]`,
        fgColor: '#509ffd',
        fgClassName: tw `ui-text-[#509ffd]`,
    },
    audius: {
        Logo: AudiusIcon,
        bgColor: '#a36efd',
        bgClassName: tw `ui-bg-[#a36efd] after:ui-bg-[#a36efd]`,
        fgColor: '#a36efd',
        fgClassName: tw `ui-text-[#a36efd]`,
        logoSizeClassName: tw `ui-size-[60%]`,
    },
    avalanche: {
        Logo: AvalancheIcon,
        bgColor: '#ff7474',
        bgClassName: tw `ui-bg-[#ff7474] after:ui-bg-[#ff7474]`,
        fgColor: '#ff7474',
        fgClassName: tw `ui-text-[#ff7474]`,
        logoSizeClassName: tw `ui-size-[60%]`,
    },
    base: {
        Logo: BaseIcon,
        bgColor: '#597aff',
        bgClassName: tw `ui-bg-[#597aff] after:ui-bg-[#597aff]`,
        fgColor: '#597aff',
        fgClassName: tw `ui-text-[#597aff]`,
    },
    bbsol: {
        Logo: BbsolIcon,
        bgColor: '#f9cc7f',
        bgClassName: tw `ui-bg-[#f9cc7f] after:ui-bg-[#f9cc7f]`,
        fgColor: '#f9cc7f',
        fgClassName: tw `ui-text-[#f9cc7f]`,
        logoSizeClassName: tw `ui-size-[70%]`,
    },
    benqi: {
        Logo: BenqiIcon,
        bgColor: '#41b3d9',
        bgClassName: tw `ui-bg-[#41b3d9] after:ui-bg-[#41b3d9]`,
        fgColor: '#41b3d9',
        fgClassName: tw `ui-text-[#41b3d9]`,
    },
    'binance-coin': {
        Logo: BinanceCoinIcon,
        bgColor: '#ffe77b',
        bgClassName: tw `ui-bg-[#ffe77b] after:ui-bg-[#ffe77b]`,
        fgColor: '#ffe77b',
        fgClassName: tw `ui-text-[#ffe77b]`,
    },
    bitcoin: {
        Logo: BitcoinIcon,
        bgColor: '#ffa774',
        bgClassName: tw `ui-bg-[#ffa774] after:ui-bg-[#ffa774]`,
        fgColor: '#ffa774',
        fgClassName: tw `ui-text-[#ffa774]`,
    },
    bonk: {
        Logo: BonkIcon,
        bgColor: '#fde665',
        bgClassName: tw `ui-bg-[#fde665] after:ui-bg-[#fde665]`,
        fgColor: '#fde665',
        fgClassName: tw `ui-text-[#fde665]`,
        logoSizeClassName: tw `ui-h-full ui-w-[60%]`,
    },
    celo: {
        Logo: CeloIcon,
        bgColor: '#fafc91',
        bgClassName: tw `ui-bg-[#fafc91] after:ui-bg-[#fafc91]`,
        fgColor: '#fafc91',
        fgClassName: tw `ui-text-[#fafc91]`,
    },
    cloud: {
        Logo: CloudIcon,
        bgColor: '#7dcdfa',
        bgClassName: tw `ui-bg-[#7dcdfa] after:ui-bg-[#7dcdfa]`,
        fgColor: '#7dcdfa',
        fgClassName: tw `ui-text-[#7dcdfa]`,
        logoSizeClassName: tw `ui-size-[65%]`,
    },
    degen: {
        Logo: DegenIcon,
        bgColor: '#a36efd',
        bgClassName: tw `ui-bg-[#a36efd] after:ui-bg-[#a36efd]`,
        fgColor: '#a36efd',
        fgClassName: tw `ui-text-[#a36efd]`,
        logoSizeClassName: tw `ui-size-[60%]`,
    },
    drift: {
        Logo: DriftIcon,
        bgColor: '#987bff',
        bgClassName: tw `ui-bg-[#987bff] after:ui-bg-[#987bff]`,
        fgColor: '#987bff',
        fgClassName: tw `ui-text-[#987bff]`,
        logoSizeClassName: tw `ui-size-[60%]`,
    },
    eurc: {
        Logo: EURCIcon,
        bgColor: '#7db6fa',
        bgClassName: tw `ui-bg-[#7db6fa] after:ui-bg-[#7db6fa]`,
        fgColor: '#7db6fa',
        fgClassName: tw `ui-text-[#7db6fa]`,
    },
    ether: {
        Logo: EtherIcon,
        bgColor: '#7db6fa',
        bgClassName: tw `ui-bg-[#7db6fa] after:ui-bg-[#7db6fa]`,
        fgColor: '#7db6fa',
        fgClassName: tw `ui-text-[#7db6fa]`,
        logoSizeClassName: tw `ui-size-[50%]`,
    },
    'ether-sepolia': {
        Logo: EtherIcon,
        bgColor: '#cce3ff',
        bgClassName: tw `ui-bg-[#cce3ff] after:ui-bg-[#cce3ff]`,
        fgColor: '#cce3ff',
        fgClassName: tw `ui-text-[#cce3ff]`,
        logoSizeClassName: tw `ui-size-[50%]`,
    },
    helio: {
        Logo: HelioIcon,
        bgColor: '#ffa774',
        bgClassName: tw `ui-bg-[#ffa774] after:ui-bg-[#ffa774]`,
        fgColor: '#ffa774',
        fgClassName: tw `ui-text-[#ffa774]`,
    },
    hsol: {
        Logo: SolanaIcon,
        bgColor: '#ff8e73',
        bgClassName: tw `ui-bg-[#ff8e73] after:ui-bg-[#ff8e73]`,
        fgColor: '#ff8e73',
        fgClassName: tw `ui-text-[#ff8e73]`,
        logoSizeClassName: tw `ui-size-[45%]`,
    },
    'index-coop': {
        Logo: IndexCoopIcon,
        bgColor: '#181818',
        bgClassName: tw `ui-bg-[#181818] after:ui-bg-[#181818]`,
        fgColor: '#181818',
        fgClassName: tw `ui-text-[#181818]`,
        inverted: true,
        logoSizeClassName: tw `ui-size-[65%]`,
    },
    immutable: {
        Logo: ImmutableIcon,
        bgColor: '#181818',
        bgClassName: tw `ui-bg-[#181818] after:ui-bg-[#181818]`,
        fgColor: '#181818',
        fgClassName: tw `ui-text-[#181818]`,
        inverted: true,
    },
    infinity: {
        Logo: InfinityIcon,
        bgColor: '#181818',
        bgClassName: tw `ui-bg-[#181818] after:ui-bg-[#181818]`,
        fgColor: '#181818',
        fgClassName: tw `ui-text-[#181818]`,
        logoSizeClassName: tw `ui-size-[70%]`,
        inverted: true,
    },
    jitosol: {
        Logo: SolanaIcon,
        bgColor: '#99e58a',
        bgClassName: tw `ui-bg-[#99e58a] after:ui-bg-[#99e58a]`,
        fgColor: '#99e58a',
        fgClassName: tw `ui-text-[#99e58a]`,
        logoSizeClassName: tw `ui-size-[45%]`,
    },
    jupiter: {
        Logo: JupiterIcon,
        bgColor: '#c9ff78',
        bgClassName: tw `ui-bg-[#c9ff78] after:ui-bg-[#c9ff78]`,
        fgColor: '#c9ff78',
        fgClassName: tw `ui-text-[#c9ff78]`,
    },
    kamino: {
        Logo: KaminoIcon,
        bgColor: '#181818',
        bgClassName: tw `ui-bg-[#181818] after:ui-bg-[#181818]`,
        fgColor: '#181818',
        fgClassName: tw `ui-text-[#181818]`,
        logoSizeClassName: tw `ui-size-[45%]`,
        inverted: true,
    },
    kroma: {
        Logo: KromaIcon,
        bgColor: '#8bd25f',
        bgClassName: tw `ui-bg-[#8bd25f] after:ui-bg-[#8bd25f]`,
        fgColor: '#8bd25f',
        fgClassName: tw `ui-text-[#8bd25f]`,
    },
    'magic-eden': {
        Logo: MagicEdenIcon,
        bgColor: '#e566a6',
        bgClassName: tw `ui-bg-[#e566a6] after:ui-bg-[#e566a6]`,
        fgColor: '#e566a6',
        fgClassName: tw `ui-text-[#e566a6]`,
        logoSizeClassName: tw `ui-size-[60%]`,
    },
    'magic-square': {
        Logo: MagicSquareIcon,
        bgColor: '#f478ff',
        bgClassName: tw `ui-bg-[#f478ff] after:ui-bg-[#f478ff]`,
        fgColor: '#f478ff',
        fgClassName: tw `ui-text-[#f478ff]`,
    },
    mantle: {
        Logo: MantleIcon,
        bgColor: '#181818',
        bgClassName: tw `ui-bg-[#181818] after:ui-bg-[#181818]`,
        fgColor: '#181818',
        fgClassName: tw `ui-text-[#181818]`,
        inverted: true,
    },
    moonbeam: {
        Logo: MoonbeamIcon,
        bgColor: '#2b1d3c',
        bgClassName: tw `ui-bg-[#2b1d3c] after:ui-bg-[#2b1d3c]`,
        fgColor: '#2b1d3c',
        fgClassName: tw `ui-text-[#2b1d3c]`,
        inverted: true,
    },
    mother: {
        Logo: MotherIcon,
        bgColor: '#ff8f73',
        bgClassName: tw `ui-bg-[#ff8f73] after:ui-bg-[#ff8f73]`,
        fgColor: '#ff8f73',
        fgClassName: tw `ui-text-[#ff8f73]`,
    },
    optimism: {
        Logo: OptimismIcon,
        bgColor: '#ff7474',
        bgClassName: tw `ui-bg-[#ff7474] after:ui-bg-[#ff7474]`,
        fgColor: '#ff7474',
        fgClassName: tw `ui-text-[#ff7474]`,
        logoSizeClassName: tw `ui-size-[60%]`,
    },
    polygon: {
        Logo: PolygonIcon,
        bgColor: '#987bff',
        bgClassName: tw `ui-bg-[#987bff] after:ui-bg-[#987bff]`,
        fgColor: '#987bff',
        fgClassName: tw `ui-text-[#987bff]`,
        logoSizeClassName: tw `ui-size-[50%]`,
    },
    quickswap: {
        Logo: QuickSwapIcon,
        bgColor: '#73b3eb',
        bgClassName: tw `ui-bg-[#73b3eb] after:ui-bg-[#73b3eb]`,
        fgColor: '#73b3eb',
        fgClassName: tw `ui-text-[#73b3eb]`,
        logoSizeClassName: tw `ui-size-[70%]`,
    },
    rari: {
        Logo: RariIcon,
        bgColor: '#b16eff',
        bgClassName: tw `ui-bg-[#b16eff] after:ui-bg-[#b16eff]`,
        fgColor: '#b16eff',
        fgClassName: tw `ui-text-[#b16eff]`,
    },
    rarible: {
        Logo: RaribleIcon,
        bgColor: '#ffea74',
        bgClassName: tw `ui-bg-[#ffea74] after:ui-bg-[#ffea74]`,
        fgColor: '#ffea74',
        fgClassName: tw `ui-text-[#ffea74]`,
    },
    raydium: {
        Logo: RaydiumIcon,
        bgColor: '#668aff',
        bgClassName: tw `ui-bg-[#668aff] after:ui-bg-[#668aff]`,
        fgColor: '#668aff',
        fgClassName: tw `ui-text-[#668aff]`,
        logoSizeClassName: tw `ui-size-[45%]`,
    },
    shapeshift: {
        Logo: ShapeShiftIcon,
        bgColor: '#759af6',
        bgClassName: tw `ui-bg-[#759af6] after:ui-bg-[#759af6]`,
        fgColor: '#759af6',
        fgClassName: tw `ui-text-[#759af6]`,
    },
    solana: {
        Logo: SolanaIcon,
        bgColor: '#72eded',
        bgClassName: tw `ui-bg-[#72eded] after:ui-bg-[#72eded]`,
        fgColor: '#72eded',
        fgClassName: tw `ui-text-[#72eded]`,
        logoSizeClassName: tw `ui-size-[45%]`,
    },
    'staked-avax': {
        Logo: StakedAvaxIcon,
        bgColor: '#7db6fa',
        bgClassName: tw `ui-bg-[#7db6fa] after:ui-bg-[#7db6fa]`,
        fgColor: '#7db6fa',
        fgClassName: tw `ui-text-[#7db6fa]`,
        logoSizeClassName: tw `ui-size-[60%]`,
    },
    tensor: {
        Logo: TensorIcon,
        bgColor: '#181818',
        bgClassName: tw `ui-bg-[#181818] after:ui-bg-[#181818]`,
        fgColor: '#181818',
        fgClassName: tw `ui-text-[#181818]`,
        logoSizeClassName: tw `ui-size-[60%]`,
        inverted: true,
    },
    tether: {
        Logo: TetherIcon,
        bgColor: '#91f2cf',
        bgClassName: tw `ui-bg-[#91f2cf] after:ui-bg-[#91f2cf]`,
        fgColor: '#91f2cf',
        fgClassName: tw `ui-text-[#91f2cf]`,
    },
    thorchain: {
        Logo: ThorchainIcon,
        bgColor: '#78ffbb',
        bgClassName: tw `ui-bg-[#78ffbb] after:ui-bg-[#78ffbb]`,
        fgColor: '#78ffbb',
        fgClassName: tw `ui-text-[#78ffbb]`,
    },
    thorswap: {
        Logo: ThorswapIcon,
        bgColor: '#34ebf5',
        bgClassName: tw `ui-bg-[#34ebf5] after:ui-bg-[#34ebf5]`,
        fgColor: '#34ebf5',
        fgClassName: tw `ui-text-[#34ebf5]`,
    },
    uniswap: {
        Logo: UniswapIcon,
        bgColor: '#ff73d7',
        bgClassName: tw `ui-bg-[#ff73d7] after:ui-bg-[#ff73d7]`,
        fgColor: '#ff73d7',
        fgClassName: tw `ui-text-[#ff73d7]`,
    },
    usdc: {
        Logo: USDCIcon,
        bgColor: '#7db6fa',
        bgClassName: tw `ui-bg-[#7db6fa] after:ui-bg-[#7db6fa]`,
        fgColor: '#7db6fa',
        fgClassName: tw `ui-text-[#7db6fa]`,
    },
    vaultcraft: {
        Logo: VaultCraftIcon,
        bgColor: '#181818',
        bgClassName: tw `ui-bg-[#181818] after:ui-bg-[#181818]`,
        fgColor: '#181818',
        fgClassName: tw `ui-text-[#181818]`,
        inverted: true,
    },
    vertex: {
        Logo: VertexIcon,
        bgColor: '#8258fc',
        bgClassName: tw `ui-bg-[#8258fc] after:ui-bg-[#8258fc]`,
        fgColor: '#8258fc',
        fgClassName: tw `ui-text-[#8258fc]`,
    },
    yeet: {
        Logo: YeetIcon,
        bgColor: '#ff8f73',
        bgClassName: tw `ui-bg-[#ff8f73] after:ui-bg-[#ff8f73]`,
        fgColor: '#ff8f73',
        fgClassName: tw `ui-text-[#ff8f73]`,
    },
    zksync: {
        Logo: ZkSyncIcon,
        bgColor: '#4c8bd4',
        bgClassName: tw `ui-bg-[#4c8bd4] after:ui-bg-[#4c8bd4]`,
        fgColor: '#4c8bd4',
        fgClassName: tw `ui-text-[#4c8bd4]`,
    },
};
